<template>
  <section :data-type="type" class="wizard-wrapper">
    <template v-if="isHeader">
      <div class="wizard-header-glow" :style="glowStyles"></div>
    </template>

    <slot name="default"></slot>
  </section>
</template>

<script>
import {nextTick} from "vue";

export default {
  props: {
    type: {required: false, type: String}
  },
  data() {
    return {
      glowExists: false,
      glowImg: null,
    }
  },

  computed: {
    isHeader() {
      return this.type === 'header';
    },

    glowStyles() {
      if (!this.isHeader || !this.glowImg) {
        return {};
      }

      return {
        backgroundImage: `url(${this.glowImg})`
      };
    }
  },

  methods: {
    addHeaderGlow() {
      const img = this.$el.querySelector('img:not([data-ignore])');
      this.glowImg = img && img.src || null;
    },

    handleScroll() {
      // tbd: is it necessary to handle scroll?
      // it should be scrolled if the glow exist
    }
  },

  mounted() {
    nextTick(() => {
      if (this.isHeader) {
        this.addHeaderGlow();
        this.handleScroll();
      }
    });
  }
}
</script>
